var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherIncome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#DF9F39"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 19.5H15.75C15.3522 19.5 14.9706 19.658 14.6893 19.9393C14.408 20.2206 14.25 20.6022 14.25 21V27C14.25 27.3978 14.408 27.7794 14.6893 28.0607C14.9706 28.342 15.3522 28.5 15.75 28.5H18.75C19.1478 28.5 19.5294 28.342 19.8107 28.0607C20.092 27.7794 20.25 27.3978 20.25 27V21C20.25 20.6022 20.092 20.2206 19.8107 19.9393C19.5294 19.658 19.1478 19.5 18.75 19.5ZM18.75 13.5H15.75C15.3522 13.5 14.9706 13.658 14.6893 13.9393C14.408 14.2206 14.25 14.6022 14.25 15V16.5C14.25 16.8978 14.408 17.2794 14.6893 17.5607C14.9706 17.842 15.3522 18 15.75 18H18.75C19.1478 18 19.5294 17.842 19.8107 17.5607C20.092 17.2794 20.25 16.8978 20.25 16.5V15C20.25 14.6022 20.092 14.2206 19.8107 13.9393C19.5294 13.658 19.1478 13.5 18.75 13.5ZM26.25 24H23.25C22.8522 24 22.4706 24.158 22.1893 24.4393C21.908 24.7206 21.75 25.1022 21.75 25.5V27C21.75 27.3978 21.908 27.7794 22.1893 28.0607C22.4706 28.342 22.8522 28.5 23.25 28.5H26.25C26.6478 28.5 27.0294 28.342 27.3107 28.0607C27.592 27.7794 27.75 27.3978 27.75 27V25.5C27.75 25.1022 27.592 24.7206 27.3107 24.4393C27.0294 24.158 26.6478 24 26.25 24ZM26.25 13.5H23.25C22.8522 13.5 22.4706 13.658 22.1893 13.9393C21.908 14.2206 21.75 14.6022 21.75 15V21C21.75 21.3978 21.908 21.7794 22.1893 22.0607C22.4706 22.342 22.8522 22.5 23.25 22.5H26.25C26.6478 22.5 27.0294 22.342 27.3107 22.0607C27.592 21.7794 27.75 21.3978 27.75 21V15C27.75 14.6022 27.592 14.2206 27.3107 13.9393C27.0294 13.658 26.6478 13.5 26.25 13.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_66"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherIncome);
export default __webpack_public_path__ + "static/media/other_income.e4ec12194374c539dc58cd3e3be4b5d2.svg";
export { ForwardRef as ReactComponent };